import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { AuthLogoutService } from '@shared/services/auth-logout.service';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private logoutSubject$ = new Subject<void>();

  constructor(private readonly authLogoutService: AuthLogoutService) {
    this.logoutSubject$
      .pipe(
        take(1),
        tap(() => {
          this.authLogoutService.showExpiredDialogAndLogout();
        }),
      )
      .subscribe();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.Unauthorized) {
          this.logoutSubject$.next();
        }

        return throwError(() => error);
      }),
    );
  }
}
